<template>
  <div>
    <div class="top">
      <div class="left">
        <img src="@/assets/image/home/logo.png" alt="" />
        <!-- <span class="des">淮河能源控股集团员工保障信息服务平台</span> -->
        <span style="padding: 0 15px; color: #dcdcdc; font-size: 15px">|</span>
        <span class="des">员工招聘平台</span>
      </div>
      <div class="right">
        <!-- <div>
          <img src="@/assets/image/home/login_icon.png" alt="" />
          <span>管理员</span>
        </div> -->
        <div class="login">
          <!-- 未登录 -->
          <div class="people" v-if="!status">
            <div @click="login" class="pointer">登录</div>
            <div style="margin: 0 10px">/</div>
            <div @click="register" class="pointer">注册</div>
          </div>
          <!-- 登录 -->
          <div v-else class="people">
            <img src="../assets/image/login/u91.png" alt="" />
            <span style="margin-right: 30px">{{ name }}</span>
            <i
              style="cursor: pointer"
              @click="logout"
              class="el-icon-switch-button"
            ></i>
          </div>
        </div>
      </div>
    </div>
    <navigation></navigation>
  </div>
</template>

<script>
import navigation from "@/components/navigation";
import { mapMutations } from "vuex";
export default {
  components: {
    navigation,
  },
  data() {
    return {
      status: false,
    };
  },
  computed: {
    /* 登录状态，刷新后从缓存取值 */
    isLogin() {
      if (sessionStorage.getItem("__usersession_uuid")) {
        const data = JSON.parse(sessionStorage.getItem("userInfo"));
        this.$store.commit("setUserInfo", data);
      }
      return this.$store.state.isLogin;
    },
    name() {
      if (this.isLogin) {
        return this.$store.state.userInfo.xm;
      } else {
        return "";
      }
    },
  },
  watch: {
    isLogin: {
      handler() {
        this.status = this.isLogin;
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations(["openLogin", "openRegister"]),
    login() {
      this.openLogin();
    },
    register() {
      this.openRegister();
    },
    /* 退出 */
    logout() {
      this.$confirm("将要退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          sessionStorage.removeItem("__usersession_uuid");
          sessionStorage.removeItem("userInfo");
          this.$store.commit("setUserInfo", {});
          this.$message({
            type: "success",
            message: "退出登录",
          });
          this.$router.push("/home");
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.top {
  display: flex;
  justify-content: space-between;
  height: 70px;
  align-items: center;
  width: 70%;
  margin: auto;
  .left {
    margin-left: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    img {
      //   width: 48px;
      //   height: 41px;
    }
    .des {
      //   font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑";
      font-weight: 700;
      font-style: normal;
      font-size: 24px;
    }
  }
  .right {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 20px;
    font-size: 16px;
    .login {
      display: flex;
      font-size: 20px;
      color: #2a8ae0;
      .people {
        display: flex;
        align-items: center;
        img {
          width: 30px;
          height: 30px;
        }
      }
      .pointer {
        &:hover {
          cursor: pointer;
        }
      }
    }
    img {
      width: 30px;
      height: 30px;
      margin-right: 15px;
    }
  }
}
</style>
